import { isEmpty } from 'lodash';
import { useUpdateEffect } from 'react-use';

import {
   HealthcareFacilitySimple,
   HealthcareFacilitySimpleForCurrentOrganizationQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { Message, MessageType, Tree } from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys } from '../../../../translations';
import { HealthcareBasicData } from '../../../common/HealthcareBasicData';

type HealthcareFacilityTreeItemsRenderProps = {
   healthcareFacilities: HealthcareFacilitySimple[];
   refetchHealthcareFacilities: VoidFunction;
};

type HealthcareFacilityTreeItemsLoaderProps = {
   readonly healthcareParentData: HealthcareBasicData;
   readonly children: (renderProps: HealthcareFacilityTreeItemsRenderProps) => JSX.Element;
};

export const HealthcareFacilityTreeItemsLoader = (props: HealthcareFacilityTreeItemsLoaderProps): JSX.Element => {
   const {
      data: healthcareFacilities,
      loading: healthcareFacilitiesLoading,
      error: healthcareFacilitiesError,
      refetch: refetchHealthcareFacilities,
   } = useCqrsSearch<HealthcareFacilitySimple>(() => {
      return new HealthcareFacilitySimpleForCurrentOrganizationQuery();
   });

   useUpdateEffect(() => {
      refetchHealthcareFacilities();
   }, [props.healthcareParentData]);

   if (healthcareFacilitiesLoading) {
      return <Tree.Loader testId={'loader'} />;
   }

   if (healthcareFacilitiesError) {
      return (
         <Message
            testId={'failedToFetchHealthcareFacility'}
            label={healthcareOrganizationTranslationKeys.failedToFetchHealthcareFacility}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   if (isEmpty(healthcareFacilities)) {
      return (
         <Tree.Placeholder
            testId={'noData'}
            label={healthcareOrganizationTranslationKeys.noAssignHealthcareFacilityLocation}
         />
      );
   }

   return props.children({
      healthcareFacilities: healthcareFacilities,
      refetchHealthcareFacilities: refetchHealthcareFacilities,
   });
};
